module.exports = __webpack_public_path__ + "img/srv7.068ac0cf.svg";